import { createAction, props } from '@ngrx/store';
import { ActionBar } from '../../models';

export const LoadActionBars = createAction('[Action Bars] Load Action Bars');
export const LoadActionBarsSuccess = createAction('[Action Bars] Load Action Bars Success', props<{ bars: ActionBar[] }>());
export const LoadActionBarsFail = createAction('[Action Bars] Load Action Bars Fail', props<{ error: any }>());
